// extracted by mini-css-extract-plugin
module.exports = {"MillionHomes":"MillionHomes_MillionHomes__PnJ2D"};